import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Icon } from '@mdi/react';
import { Collapse, CollapseProps } from '@mui/material';
import { BaseButton, Variables } from '../base';
import { Sidebar } from './sidebar';
import { SidebarItem } from './sidebar-item';

const appSidebarItemStyles = css`
    color: #3e4d64 !important;
    padding-left: 8px;
    padding-right: 8px;
    margin: 8px 20px;
    width: calc(100% - 40px);
    height: 32px;
    border-radius: 12px;
    border-left: 5px solid transparent !important;

    &.active {
        color: #3e4d64 !important;
        background-color: #dae0e7;
        border-left: 5px solid transparent !important;
    }

    &:hover {
        color: #3e4d64 !important;
        background-color: #dae0e7;
    }

    &:focus,
    &:active {
        color: #3e4d64 !important;
    }
`;

export const AppSidebar = styled(Sidebar)`
    display: flex;
    flex-direction: column;
    background-color: ${Variables.Colors.sidebarBackground};
    border-right: 1px solid #dae0e7;
`;

export const AppSidebarItem = styled(SidebarItem)`
    ${appSidebarItemStyles}
`;

export const AppSidebarSubItem = styled(SidebarItem)`
    ${appSidebarItemStyles}
`;

export const AppSidebarRestrictedItem = styled(SidebarItem)`
    font-style: italic;
`;

export const AppSidebarMessageCount = styled.span`
    display: inline-block;
    text-align: center;
    margin-left: 8px;
    padding: 0 4px;
    height: 18px;
    min-width: 18px;
    width: auto;
    border-radius: 18px;
    font-size: 13px;
    line-height: 18px;
    font-weight: 500;
    color: ${Variables.Colors.white};
    background-color: ${Variables.Colors.b300};
`;

export const AppSidebarCollapse = styled(Collapse)<CollapseProps>`
    width: 100%;
    flex-shrink: 0;

    a {
        display: block;
        width: 100%;
        text-decoration: none;
    }
`;

export const AppSidebarNestedCollapse = styled(AppSidebarCollapse)`
    padding-left: 10px;
`;

export const AppSidebarCollapseButton = styled(BaseButton)`
    width: 24px;
    height: 24px;
    min-width: 0;
    padding: 0;
    background-color: transparent;
    margin-left: auto;
    margin-right: 12px;
`;

export const AppSidebarNestedCollapseButton = styled(AppSidebarCollapseButton)`
    margin-left: 18px;
`;

export const AppSidebarCollapseIcon = styled(Icon)<{ open: boolean }>`
    fill: ${Variables.Colors.sidebarIconColor};
    transition: ${Variables.transition};
    width: 32px;
    height: 32px;
`;

export const AppSidebarExpandButton = styled(BaseButton)`
    width: 24px;
    height: 24px;
    min-width: 0;
    padding: 0;
    background-color: transparent;
    position: absolute;
    transform: translateX(-120%);
`;

export const AppSidebarExpandIcon = styled(Icon)<{ open: boolean }>`
    fill: ${Variables.Colors.sidebarIconColor};
    transition: ${Variables.transition};
    transform: rotate(${(props): number => (props.open ? 90 : 0)}deg);
`;

export const AppSidebarCollapseIndent = styled.span`
    display: inline-block;
    width: 18px;
`;

export const AppSidebarSpacer = styled.div`
    flex-grow: 1;
`;

export const AppSidebarMenuIcon = styled(Icon)`
    margin-right: 12px;
    fill: ${Variables.Colors.sidebarIconColor};
    flex-shrink: 0;
    width: 32px;
    height: 32px;
`;

export const AppSidebarSubMenuIcon = styled(Icon)`
    margin-right: 8px;
    fill: ${Variables.Colors.sidebarIconColor};
    flex-shrink: 0;
    width: 32px;
    height: 32px;
`;
